module.exports = __webpack_public_path__ + "static/media/noti3.82d5d426.png";